import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const cvComment = {
  // 添加简历点评
  addCvComment: (token, payload) => {
    return api.post(proxyApi + `/v3/cvs/${ token }/cv_comments`, payload)
  },
  // 获取简历点评数据
  getWholeCommentData: (token, payload) => {
    return api.get(proxyApi + `/v3/cvs/${ token }/cv_comments`, payload)
  },
  // 删除简历点评
  deleteCvComment: (token, commentId) => {
    return api.delete(proxyApi + `/v3/cvs/${ token }/cv_comments/${ commentId }`)
  },
  // 获取所有简历批注
  getCommentData: (token, payload) => {
    return api.get(proxyApi + `/v3/cvs/${ token }/all_cv_comments`, payload)
  }
}
export default cvComment
